import { getCookie } from 'react-use-cookie';
export const getDeviceInfo = () => {
    const deviceCookie = getCookie('wh_device');
    const deviceInfo = deviceCookie ? JSON.parse(deviceCookie) : {};
    deviceInfo.isNative = (typeof deviceInfo.is_native === 'string')
        ? (deviceInfo.is_native === 'true')
        : deviceInfo.is_native;
    deviceInfo.deviceOS = deviceInfo.device_os;
    delete deviceInfo.is_native;
    delete deviceInfo.device_os;
    return deviceInfo;
};
